import * as React from 'react';
import { styled } from '@mui/system';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { DEFAULT_CAFE_IMG } from '../../../../utils/constant';

const CardMediaWrapper = styled('div')(({ theme }) => ({
  maxWidth: '225px',
  height: '225px',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('850')]: {
    marginLeft: '130px',
  },
  [theme.breakpoints.down('450')]: {
    marginLeft: '85px',
  },
  [theme.breakpoints.down('370')]: {
    marginLeft: '70px',
  },
}));

const CardMediaContainer = styled(Swiper)(() => ({
  position: 'relative',
  maxWidth: '225px',
  maxHeight: '225px',
  filter: 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.4))',
  margin: 'auto 0',
  '& .swiper-button-prev::after,.swiper-button-next::after ': {
    color: 'rgba(255, 255, 255, 0.8)',
  },
  '& .swiper-pagination-bullet-active': {
    backgroundColor: '#D9D9D9A6',
  },
  '& .swiper-wrapper': {
    alignItems: 'center',
  },
}));

const PictureCarouselGroup = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '10px',
  marginLeft: '-4px',
  '& .swiper-wrapper': {
    alignItems: 'center',
  },
}));
const DefaultPics = styled('div')({});

const AvatarGroup = styled(SwiperSlide)({});

const Avatar = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const DefaultPicture = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const CafeMedia = (props) => {
  return (
    <CardMediaWrapper>
      <CardMediaContainer
        spaceBetween={30}
        navigation={true}
        pagination={{
          clickable: true,
        }}
        modules={[EffectFade, Navigation, Pagination]}
        style={{
          '--swiper-navigation-size': '18px',
        }}
      >
        <PictureCarouselGroup>
          {props.cafePics.length === 0 ? (
            <DefaultPics>
              <DefaultPicture src={DEFAULT_CAFE_IMG} />
            </DefaultPics>
          ) : (
            props.cafePics.map((currentAvatar, key) => {
              return (
                <AvatarGroup key={key}>
                  <Avatar src={currentAvatar.url} alt={currentAvatar.name} />
                </AvatarGroup>
              );
            })
          )}
        </PictureCarouselGroup>
      </CardMediaContainer>
    </CardMediaWrapper>
  );
};
export default CafeMedia;
